import { Component, OnInit, ViewChild, Input, Output, EventEmitter, Inject } from '@angular/core';
import { Offer } from 'app/services/offers/offer.model';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { Store } from '@ngxs/store';
import { UpdateOfferOptionTerms } from 'ng2-app/store/offers/offer-options.actions';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-offer-option-edit-dialog',
  templateUrl: './offer-option-edit-dialog.component.html',
  styleUrls: [],
  standalone: false
})
export class OfferOptionEditDialogComponent implements OnInit {

  editApprovalData: any;
  initializeModalCalculator: boolean = false;
  optionLoanCategoryType: string;

  @Input() optionParent: Approval | Offer;
  @Input() optionParentName: string;
  @Input() optionType: string;
  @Input() option: OfferOption;

  @Output() offerOptionUpdated = new EventEmitter<object>();

  approvalCalculatorData: object;

  constructor(
    private store: Store,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<OfferOptionEditDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.optionLoanCategoryType =
      this.data?.option?.deal?.loan_product?.category?.type || '';

    if(this.data?.optionType === 'approval'){
      this.editApprovalData = {
        term: this.data?.option.termSet.term,
        paymentFrequency: this.data?.option.termSet.paymentFrequency,
        points: this.data?.option.termSet.points,
        paymentCount: this.data?.option.termSet.paymentCount,
        paymentAmount: this.data?.option.termSet.paymentAmount,
        commission: this.data?.option.termSet.commission,
        ...this.buildAdditionalOptionData(),
      };
      this.initializeModalCalculator = true;
    }
  }

  handleCalculationUpdate($event){
    this.approvalCalculatorData = $event;
  }

  saveOption(optionType){
    if(optionType === 'approval'){
      if(!!this.approvalCalculatorData){
        this.store.dispatch( new UpdateOfferOptionTerms(this.data?.option.dealId, this.data?.option.id, this.approvalCalculatorData) );
        this.offerOptionUpdated.emit(this.approvalCalculatorData);
        this.dialogRef.close();
      }
    }
  }

  buildAdditionalOptionData() {
    switch (this.optionLoanCategoryType) {
      case 'loc':
        return {
          creditLimit: this.data?.option.termSet.creditLimit,
          amount: this.data?.option.termSet.initialDrawAmount,
          periodicRate: this.data?.option.termSet.periodicRate,
          periodsPerYear: this.data?.option.termSet.periodsPerYear,
          annualInterestRate: this.data?.option.termSet.annualInterestRate,
          apr: this.data?.option.termSet.apr,
          originationPercent: this.data?.option.termSet.drawFeePercent,
          originationAmount: this.data?.option.termSet.drawFeeAmount,
        };
      case 'term':
        return {
          amount: this.data?.option.termSet.amount,
          periodicRate: this.data?.option.termSet.periodicRate,
          periodsPerYear: this.data?.option.termSet.periodsPerYear,
          annualInterestRate: this.data?.option.termSet.annualInterestRate,
          apr: this.data?.option.termSet.apr,
          originationPercent: this.data?.option.termSet.originationFeePercent,
          originationAmount: this.data?.option.termSet.originationFeeAmount,
        };
      case 'ach':
      default:
        return {
          amount: this.data?.option.termSet.amount,
          originationPercent: this.data?.option.termSet.originationFeePercent,
          factorRate: this.data?.option.termSet.factorRate,
          payback: this.data?.option.termSet.payback,
          originationAmount: this.data?.option.termSet.originationFeeAmount,
          disbursement: this.data?.option.termSet.disbursement,
        };
    }
  }
}
